<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('claimPayout.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('claimPayout.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td valign="middle">{{ record.dealer_code }}</td>
          <td valign="middle">{{ record.dealer_name }}</td>
          <td>{{ record.primary_contact }}</td>
          <td>{{ record.id_passport_no }}</td>
          <td class="text-center">
            <a
              href="#"
              @click.prevent="claim(record)"
              v-tooltip="$t('claimPayout.claim')"
            >
              <i class="far fa-hand-rock"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <a-modal
      v-model="show_form"
      :title="$t('claimPayout.pageTitle')"
      :okText="$t('save')"
      :cancelText="$t('cancel')"
      :confirmLoading="waiting"
      @cancel="clearInput"
      @ok="onSave"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="ts-p-2 ts-rounded-md ts-shadow-md ts-flex ts-items-center ts-justify-between"
          >
            <strong class="ts-text-base">{{
              $t('claimPayout.balance')
            }}</strong>
            <div
              class="ts-h-8 ts-border-2 ts-border-pink-600 ts-flex ts-items-center ts-px-2 ts-rounded-lg"
            >
              <strong>{{ model.payout_balance }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row ts-mt-4">
        <div class="col-md-12">
          <label class="required">{{ $t('claimPayout.claimAmount') }}</label>
          <input
            v-model.number="model.claim_amount"
            type="number"
            step="any"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('claim_amount')">
            {{ errors.first('claim_amount') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label>{{ $t('claimPayout.description') }}</label>
          <textarea
            rows="3"
            class="form-control"
            v-model="model.description"
          ></textarea>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'gameBetting',
  data() {
    return {
      visible: false,
      loading: false,
      waiting: false,
      show_form: false,
      errors: new Errors(),
      model: {
        claim_amount: null,
        dealer_id: null,
        description: null,
        payout_balance: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/claimPayout', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.claimPayout.search
      },
      set(newValue) {
        this.$store.commit('accounting/claimPayout/SET_SEARCH', newValue)
        this.$store.commit('accounting/claimPayout/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('claimPayout.dealerCode') },
        { name: this.$t('claimPayout.dealerName') },
        { name: this.$t('claimPayout.phone') },
        { name: this.$t('claimPayout.passportNo') },
        { name: this.$t('actions'), style: 'text-align:center; width:10px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/claimPayout/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    claim(record) {
      this.show_form = true
      this.model.dealer_id = record.dealer_id
      this.model.payout_balance = record.payout_balance
    },
    clearInput() {
      this.show_form = false
      this.model.claim_amount = null
      this.model.dealer_id = null
      this.model.description = null
      this.model.payout_balance = 0
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('accounting/claimPayout/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.show_form = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('accounting/claimPayout/RESET_STATE')
    next()
  }
}
</script>
